export default __webpack_public_path__ + "static/media/armadillo-pipe-guard.e8bc8a50.mp4";